import React, { useState } from "react"
import TextField from "@mui/material/TextField"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import Button from "@mui/material/Button"

import { StyledMemberSearch, StyledMemberSearchBar } from "./Member.style"

const MemberSearch = ({ setSearchOptions }) => {
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [isGuest, setIsGuest] = useState(-1)
  const [isTrial, setIsTrial] = useState(-1)
  const [isBetaTester, setIsBetaTester] = useState(-1)
  const [hasCoach, setHasCoach] = useState(-1)
  const [status, setStatus] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const clearSearch = () => {
    setEmail("")
    setName("")
    setIsGuest(-1)
    setIsTrial(-1)
    setIsBetaTester(-1)
    setHasCoach(-1)
    setStatus(1)
    setPageSize(10)
  }

  const searchAction = () => {
    const options = {
      pageNo: 1,
      pageSize: pageSize,
      searchName: name,
      searchEmail: email,
      isGuest: isGuest === -1 ? null : isGuest,
      trialFlag: isTrial === -1 ? null : isTrial,
      isBetaTester: isBetaTester === -1 ? null : isBetaTester,
      hasCoach: hasCoach === -1 ? null : hasCoach,
      isActive: status,
    }
    setSearchOptions(options)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    searchAction()
  }

  return (
    <StyledMemberSearch>
      <StyledMemberSearchBar as="form" onSubmit={handleSubmit}>
        <TextField
          className="filter-name"
          autoFocus
          autoComplete="off"
          id="member-search-user-name"
          label="Name"
          type="text"
          value={name}
          onChange={(e) => {
            setName(e.target.value)
          }}
          variant="outlined"
          size="small"
        />
        <TextField
          className="filter-email"
          autoComplete="off"
          id="member-search-user-email"
          label="Email"
          type="text"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
          variant="outlined"
          size="small"
        />
        <FormControl className="filter-sm" size="small">
          <InputLabel id="member-is-guest-select-label">Is Guest</InputLabel>
          <Select
            labelId="member-is-guest-select-label"
            id="member-is-guest-select"
            value={isGuest}
            label="Is Guest"
            onChange={(e) => {
              setIsGuest(e.target.value)
            }}
          >
            <MenuItem value={-1}>All</MenuItem>
            <MenuItem value={0}>Member</MenuItem>
            <MenuItem value={1}>Guest</MenuItem>
          </Select>
        </FormControl>
        <FormControl className="filter-sm" size="small">
          <InputLabel id="member-is-trial-select-label">Is Trial</InputLabel>
          <Select
            labelId="member-is-trial-select-label"
            id="member-is-trial-select"
            value={isTrial}
            label="Is Trial"
            onChange={(e) => {
              setIsTrial(e.target.value)
            }}
          >
            <MenuItem value={-1}>All</MenuItem>
            <MenuItem value={0}>Member</MenuItem>
            <MenuItem value={1}>Trial</MenuItem>
          </Select>
        </FormControl>
        <FormControl className="filter-md" size="small">
          <InputLabel id="member-is-beta-select-label">Beta Tester</InputLabel>
          <Select
            labelId="member-is-beta-select-label"
            id="member-is-beta-select"
            value={isBetaTester}
            label="Beta Tester"
            onChange={(e) => {
              setIsBetaTester(e.target.value)
            }}
          >
            <MenuItem value={-1}>All</MenuItem>
            <MenuItem value={1}>Yes</MenuItem>
            <MenuItem value={0}>No</MenuItem>
          </Select>
        </FormControl>
        <FormControl className="filter-md" size="small">
          <InputLabel id="member-has-coach-select-label">Coach Connection</InputLabel>
          <Select
            labelId="member-has-coach-select-label"
            id="member-has-coach-select"
            value={hasCoach}
            label="Coach Connection"
            onChange={(e) => {
              setHasCoach(e.target.value)
            }}
          >
            <MenuItem value={-1}>All</MenuItem>
            <MenuItem value={1}>Connected to a coach</MenuItem>
          </Select>
        </FormControl>
        <FormControl className="filter-md" size="small">
          <InputLabel id="member-is-active-select-label">Status</InputLabel>
          <Select
            labelId="member-is-active-select-label"
            id="member-is-active-select"
            value={status}
            label="Status"
            onChange={(e) => {
              setStatus(e.target.value)
            }}
          >
            <MenuItem value={1}>Activated</MenuItem>
            <MenuItem value={0}>Deactivated</MenuItem>
          </Select>
        </FormControl>
        <FormControl className="filter-sm" size="small">
          <InputLabel id="member-page-size-select-label">Page Size</InputLabel>
          <Select
            labelId="member-page-size-select-label"
            id="member-page-size-select"
            value={pageSize}
            label="Page Size"
            onChange={(e) => {
              setPageSize(e.target.value)
            }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
        <div className="search-actions">
          <Button
            className="search-btn"
            variant="contained"
            size="medium"
            type="submit"
          >
            Search
          </Button>
          <Button
            className="search-btn"
            variant="outlined"
            size="medium"
            type="button"
            onClick={clearSearch}
          >
            Clear
          </Button>
        </div>
      </StyledMemberSearchBar>
    </StyledMemberSearch>
  )
}

export default MemberSearch
